import React from 'react';
import { Link } from 'react-router-dom';
import { useCatalog } from '../../context/CatalogContext';
import './BrandSection.css';

const BrandSection = () => {
  const { brands } = useCatalog();
  return (
    <section className="brand-section">
      <div className="container">
        <h2 className="section-title">Shop by Brand</h2>
        
        <div className="brand-grid">
          {brands.map(brand => (
            <Link 
              to={`/shop?brand=${brand.slug}`} 
              key={brand.id || brand.slug}
              className="brand-card"
            >
              <div className="brand-logo">
                <span>{brand.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
